import React from "react";
import { motion } from "framer-motion";
import abbie2 from "../../assets/abbie-2.jpg";
import ColoredTitle from "./ColoredTitle";

export default function AboutSection() {
  return (
    <section
      id="about"
      className="min-h-screen px-4 sm:px-8 md:px-12 lg:px-20 xl:px-28
        pt-16 pb-16 sm:pt-20 md:pt-16 lg:pt-20"
    >
      {/* Sticky title */}
      <div className="sticky top-0 z-20 bg-lightBeige pt-16 pb-3 transition-shadow duration-300 -mx-4 sm:-mx-8 md:-mx-12 lg:-mx-20 xl:-mx-28 px-4 sm:px-8 md:px-12 lg:px-20 xl:px-28 mb-6 sm:mb-8 md:mb-10 text-center">
        <h1 className="font-extrabold text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl">
          <ColoredTitle text="About." />
          <span
            className="font-semibold pl-3 sm:pl-4 md:pl-6 lg:pl-10
            text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-7xl"
          >
            Yu Luo
          </span>
        </h1>
      </div>

      {/* Divider */}
      <div className="flex justify-center mb-8 sm:mb-10 md:mb-14">
        <div className="h-[3px] bg-lightBrown rounded-full w-28 sm:w-36 md:w-48 lg:w-64"></div>
      </div>

      {/* Photo + text — stacked on mobile, side-by-side on md+ */}
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.55, ease: "easeOut" }}
        className="flex flex-col md:flex-row md:items-start
        gap-6 sm:gap-8 md:gap-10 lg:gap-14 xl:gap-20"
      >
        {/* Photo — centred on mobile, left-aligned on md+ */}
        <div className="shrink-0 w-1/2 sm:w-2/5 md:w-1/3 lg:w-[28%] xl:w-1/4 md:mt-2 mx-auto md:mx-0">
          <img
            src={abbie2}
            alt="Abbie"
            className="w-full h-auto"
            style={{ borderRadius: "100px 200px 90px 160px" }}
          />
        </div>

        {/* Text column */}
        <div className="flex flex-col justify-center gap-3 sm:gap-4 md:gap-5 lg:gap-6">
          {/* Greeting */}
          <div className="flex flex-col gap-1">
            <p
              className="font-semibold text-center
              text-xl sm:text-2xl md:text-2xl lg:text-3xl xl:text-4xl pr-28 sm:pr-40 md:pr-52"
            >
              Hi! You can call me Abbie :)
            </p>
            <p
              className="font-normal text-brown text-center
              text-lg sm:text-xl md:text-xl lg:text-2xl xl:text-3xl pl-28 sm:pl-40 md:pl-52"
            >
              an analyst & engineer on AI products.
            </p>
          </div>

          {/* Divider */}
          {/* <div className="w-10 sm:w-12 h-[2px] bg-lightBrown rounded-full"></div> */}

          {/* Bio */}
          <p
            className="leading-relaxed text-midBrown
            text-sm sm:text-base md:text-base lg:text-lg xl:text-xl"
          >
            I work where users, product, design and engineering meet, turning
            messy requirements and unstructured data into AI products people can
            rely on. I've built full-stack platforms and LLM pipelines as a
            software engineer, and I care just as much about the work around
            them: data quality checks, testing, and clear documentation.
          </p>
          <p
            className="leading-relaxed text-midBrown
            text-sm sm:text-base md:text-base lg:text-lg xl:text-xl"
          >
            Most recently I built an LLM-based data ingestion pipeline at
            iOffer. I'm currently learning as an External Student Researcher at
            the University of Arizona's NAIADEL Lab.
          </p>
          <p
            className="leading-relaxed text-midBrown
            text-sm sm:text-base md:text-base lg:text-lg xl:text-xl"
          >
            I speak Mandarin, Cantonese and English. Explore my work below, and
            let's connect!
          </p>
        </div>
      </motion.div>
    </section>
  );
}
